import React, {useEffect} from "react";
import { useLocation, Link } from "react-router-dom";
import "../promotionPage/promotionPage.css"
import Loading from "../../base/loading/loading";
import { Helmet } from "react-helmet";
import TopMenu from "../../base/topMenu/topMenu";
import LandingCarousel from "../../base/landingCarousel/landingCarousel";
import MultiCarousel from "../../base/multiCarousel/multiCarousel";
import AllPromotions from "../../base/allPromotions/allPromotions";
import Header from "../../base/header/header";
import Footer from "../../base/footer/footer";
import {getPageData, validatePath} from "../../../utils/generals"


// const query = `
// {
//     promotionsPageCollection{
//       items{
//         internalName
//         pageTitle
//         slug
//         seoMetadata{
//           description
//           hreflang
//           href
//           canonicalHref
//         }
//         nav{
//           logo{
//             description
//             url
//           }
//           menuItems
//         }
//         carouselLp
//         multiCarouselCollection{
//           items{
//             url
//             description
//           } 
//         }
//         promotions{
//           title{
//             json
//           }
//           categories
//           promotions
//           promotions1 
//           promotions2
//           promotions3
//         }
//         downloadAppButtons{
//           title
//           downloadButtons
//         }
//         footer{
//           text
//           socialMedia
//         }
//         urlAccount
//       }
//     }
//   }
// `;

let query = `
         {
            promotionsPageCollection(where: {seoMetadata: {path:"&slug&"}}) {
            items{
                internalName
                pageTitle
                slug
                seoMetadata{
                    description
                    hreflang
                    href
                    canonicalHref
                }
                nav{
                    logo{
                    description
                    url
                    }
                    menuItems
                }
                carouselLp
                multiCarouselCollection{
                    items{
                    url
                    description
                    } 
                }
                promotions{
                    title{
                    json
                    }
                    categories
                    promotions
                    promotions1 
                    promotions2
                    promotions3
                }
                downloadAppButtons{
                    title
                    downloadButtons
                }
                footer{
                    text
                    socialMedia
                }
                urlAccount
                }
            }
        }
`


const PromotionPage = () => {


    const [page, setPage] = React.useState(null);
    const location = useLocation();
    const [keyCountry, setKeyCountry] = React.useState(null);



    useEffect(()=> {


        query = query.replace("&slug&", validatePath(location.pathname));
      const pageData = getPageData(query);

      const codeCountry = String(location.pathname).split("/");
      setKeyCountry(codeCountry[1]);

      pageData
        .then((res) => {
            
            
            const data0 = res.promotionsPageCollection.items[0].promotions.promotions?.items;
            const data1 = res.promotionsPageCollection.items[0].promotions.promotions1?.items ;
            const data2 = res.promotionsPageCollection.items[0].promotions.promotions2?.items;
            const data3 = res.promotionsPageCollection.items[0].promotions.promotions3?.items;

             let fullPromotions = [];
             fullPromotions = fullPromotions.concat(data0, data1, data2, data3)
             fullPromotions = fullPromotions.filter(function( element ) {
                return element !== undefined;
             });

            setTimeout(function() {
                res.promotionsPageCollection.items[0].promotions.promotions.items = fullPromotions;
                setPage(res.promotionsPageCollection.items[0]);
            }, 400);
        })
        .catch((errors) => {
          console.log(errors);
        });

        // const url = String(location.pathname).split("/");
        // const slug = url[2];
        // console.log("slug", slug);
        // setKeyCountry(url[1])
        // query = query.replace('&slug&', slug)
        // // console.log('query', query)
        // window
        // .fetch(`https://graphql.contentful.com/content/v1/spaces/5btn2y9mgkqy/`, {
        //     method: "POST",
        //     headers: {
        //     "Content-Type": "application/json",
        //     // Authenticate the request
        //     Authorization: "Bearer b3AQUpg-vBOOEAh9q_GsxA5r5Iq170qfW8BnsdAjObE",
        //     },
        //     // send the GraphQL query
        //     body: JSON.stringify({ query  }),
        // })
        // .then((response) => response.json())
        // .then(({ data, errors }) => {
        //     if (errors) {
        //     console.error("erros", errors);
        //     }

        //     // rerender the entire component with new data
        //     console.log("data", data);

        //     const data0 = data.promotionsPageCollection.items[0].promotions.promotions?.items;
        //     const data1 = data.promotionsPageCollection.items[0].promotions.promotions1?.items ;
        //     const data2 = data.promotionsPageCollection.items[0].promotions.promotions2?.items;
        //     const data3 = data.promotionsPageCollection.items[0].promotions.promotions3?.items;

        //      let fullPromotions = [];
        //      fullPromotions = fullPromotions.concat(data0, data1, data2, data3)
        //      fullPromotions = fullPromotions.filter(function( element ) {
        //         return element !== undefined;
        //      });
        //     //console.log('heee', data.promotionsPageCollection.items[0].promotions.promotions.items)
        //     //console.log('full promotions', fullPromotions)

        //     data.promotionsPageCollection.items.forEach((element, index) => {
        //     if (element.slug === slug) {
        //         setTimeout(function(){
        //         data.promotionsPageCollection.items[0].promotions.promotions.items = fullPromotions;
        //         setPage(data.promotionsPageCollection.items[index]);
        //         // console.log("lp data",data.promotionsPageCollection.items[index]);
        //         },400)
        //     }
        //     });

        //     // setPage(data.homePageCollection.items[0]);
        // });

    }, [location.pathname])

    if (!page) {
        return(<Loading />)
    }


    return (
    <div className="container-fluid no-padding lp-container ">
        <Helmet htmlAttributes={{ lang : page.seoMetadata.hreflang }}>
            <meta charSet="utf-8" />
            <title>{page.pageTitle}</title>
            <meta name="description" content={page.seoMetadata.description}></meta>
            <meta name="keywords" content={page.seoMetadata.keywords}></meta>
            <link
            rel="alternate"
            hreflang={page.seoMetadata.hreflang}
            href={page.seoMetadata.href}
            />
            <link rel="canonical" href={page.canonicalHref} />
        </Helmet>
        
        
        <div className='container-fluid main-container'>
            {/* <div className="top-menu "></div> */}
            <TopMenu urlAccount={page.urlAccount} urlAppButtos={page.downloadAppButtons.downloadButtons} />

            <Header logo={page.nav.logo} menuItems={page.nav.menuItems.menu} />


            {/* <div className="container ">
                <div className="row masthead  ">
                    <div className="col-10  col-md-2 no-padding d-flex align-items-center">
                    
                        <img
                        className="masthead-image"
                        src={page.nav.logo.url}
                        alt="main images"
                        />
                    </div>
                    <div className="col-2  col-md-10  d-none d-sm-block d-sm-none d-md-block">
                        <div className="row pt-4 h-100 items-container d-flex justify-content-end  ">
                            
                            <div  className="menu-item">
                                <Link onClick={()=>setItemScroll('test1')} activeClass="active-lp" className="item-aref" to="test1" spy={true} smooth={true} duration={200} offset={-300} >
                                    
                                    <a href="#">{page.nav.menuItems.menu[0].label || ""}</a>
                                </Link>
                            </div>
                            <div  className="menu-item">

                                <Link onClick={()=>setItemScroll('test2')} activeClass="active-lp" className="item-aref" to="test2" spy={true} smooth={true} duration={200} offset={-300} >
                                   <a href="#">
                                    {page.nav.menuItems.menu[1].label || ""}
                                   </a>
                                </Link>

                            </div>
                            <div  className="menu-item-btns d-none d-sm-block d-sm-none d-md-block ">
                                 <div className="row ">
                                    <span className="col-6 ">
                                        ¡Descarga ya!
                                    </span>
                                    <div className="col-6  ">
                                        <div className="row  " style={{marginTop: '-5px'}}>
                                            <div className="col-6  s-btn d-flex justify-content-center">
                                                <a href={page.downloadAppButtons.downloadButtons.items[1].cta} target="_blank" rel="noreferrer">
                                                    <img className="img-btn-s " src={gPlayS}  alt="gplay"/>
                                                </a>
                                            </div>
                                            <div className="col-6  s-btn  d-flex justify-content-center">
                                                <a href={page.downloadAppButtons.downloadButtons.items[0].cta} target="_blank" rel="noreferrer">
                                                    <img className="img-btn-s  " src={aStoreS}  alt="appstore"/>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                 </div>  
                            </div>
                        </div>

                    </div>
                </div>
            </div>  */}

        </div>

        <section className="pt-1">
            <div>
                <h1 className="d-none">{page.pageTitle}</h1>
                <LandingCarousel data={page.carouselLp} downloadAppButtons={page.downloadAppButtons}/>
            </div>
        </section>
            

        <section className="container-fluid pt-1 pb-4">
            <MultiCarousel data={page.multiCarouselCollection}/>
        </section>

        <section>
            <AllPromotions data={page.promotions} />
        </section>

        <Footer data={page.footer}/>
            <div className=" p-1 container-fluid  tyc-container d-flex justify-content-center">
                <Link to={"/legales?id=homePageCollection&slug=home-"+keyCountry}>
                    Términos y Condiciones
                </Link>
            </div>

    </div>
    )
}


export default PromotionPage